import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { LoadingBasic } from './LoadingBasic';
import { THEME } from '@meetbutter/ui';
import { trackPageView } from 'utils/Tracking';

export const RouteLoader = () => {
  const router = useRouter();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleStart = () => setLoading(true);

    const handleComplete = url => {
      if (url) {
        /**
         * While changing route
         */
        trackPageView({ path: url });
      }

      setLoading(false);
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, []);

  if (loading) {
    return (
      <LoadingBasic
        absolute={true}
        bgcolor={THEME.colors.primary.IceterineYellow100}
        text="Loading page..."
      />
    );
  }

  return null;
};
